export default "__VITE_ASSET__BEpvyqBR__"